import { render } from "./Overlay.vue?vue&type=template&id=4ae0103c&scoped=true&bindings={\"currentSpot\":\"props\",\"location\":\"setup\",\"open\":\"setup\"}"
import script from "./Overlay.vue?vue&type=script&lang=js"
export * from "./Overlay.vue?vue&type=script&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=4ae0103c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ae0103c"

export default script